import { Injectable } from '@angular/core';
import { GlobalsService } from '../../../_core/globals.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class WhitePaperSyncService {

  constructor(private globalSvc: GlobalsService, private http: HttpClient) { 

  }
  apiCampaignSync: string = `${this.globalSvc.env.dxCampaignSyncUrl}/leads`
  apiCampaignSyncLogs: string = `${this.globalSvc.env.dxCampaignSyncUrl}/ContentHubLogs`
  getCampaignById(id:number): Observable<any> {
      return  this.http.get<any>(`${this.apiCampaignSync}/getCampaignById?campaignId=${id}`); 
  }
  getWhitePaperByCriteria(params:any): Observable<any> {
    // return  this.http.post<any>(`${this.apiCampaignSync}/getWhitePapers`, params); 
    return new Observable<any>((observer) => {
      this.http.post<any>(`${this.apiCampaignSync}/getWhitePapers`, params).subscribe(data => {
        // data.data.items = data.data.items.map((item:any) => {
        //     item.whitePaperLinkLabel = {
        //       label: item.title,
        //       link: item.whitePaperLink
        //     }
        //     return item;
        //  })
        let itemsRow: any[] = []; 
        if(data.data.items.length > 0){
            data.data.items.forEach((log:any) => {
                          log.criteriaForLogs = {
                           whitePaperId: log.whitePaperId
                          }
                          log.whitepaperTitle = log.title;

                          if(log.existingTitles && log.existingTitles.length > 0){
                            log["wpIcon"] = "pi-exclamation-triangle";
                          }
                          
                          log.lastSyncDateTime = log.landingPages[0]?.lastSyncDateTime || "";
                          log.whitepaperId = log.whitePaperId;
                          log.isVisible = true;
                          log.selectedData = [];
                          var hasLandingPageSync = log.landingPages.find((a:any) => a.lastSyncDateTime !== null);
                          if(!hasLandingPageSync){
                            log.whitePaperIdLink = {
                              label: log.whitePaperId
                            }
                            log.valType = 'text';
                          }else{
                            log.valType = 'label';
                            log.msgtooltip = "View Whitepaper Logs"
                            log.whitePaperIdLink = log.whitePaperId
                          }
                          let endDate = new Date(log.campaignEndDate);
                          let expiredDate = new Date(endDate.setMonth(endDate.getMonth() + 6));
                          if(expiredDate > new Date()){
                            log.wpStatusColor = "completed-green"
                            log["whitePaperStatus"] = "Active";
                          }else{
                            log.wpStatusColor = "failed-red"
                            log["whitePaperStatus"] = "Expired";
                          }
                          switch(log.campaignStatus){
                            case 'Inactive': {
                              log.statusColor = "started-yellow"
                              break;
                            }
                            case 'Active': {
                              log.statusColor = "completed-green"
                              break;
                            }
                            case 'Ended': {
                              log.statusColor = "failed-red"
                              break;
                            }
                            case 'Pause': {
                              log.statusColor = "inprogress-blue"
                              break;
                            }
                          }

                          if(log.landingPages && log.landingPages.length > 0){
                            log.landingPages = log.landingPages.map((row:any, index:number) => {
                                row.whitePaperLinkLabel = {
                                  label: "View",
                                  link: row.whitePaperLink
                                }
                                row.isVisible = true;
                                row.isDisabled = true;
                                row.isLPChecked = false;
                                row.wpUrl = row.whitePaperLink;
                                let slinks: any[] =  [];
                                row.stLink = { link: "", label: "Not Yet Synced", valType: 'text', site: 1,
                                  hasExistingTitle: log.existingTitles.find((d:any)=> d.siteIds.indexOf(1) > -1)? true:false,
                                  isHidden: row.siteVisibility[1],
                                  hiddenIcon: row.siteVisibility[1]? "pi pi-eye": "pi pi-eye-slash"
                                };
                                row.egLink = { link: "", label: "Not Yet Synced", valType: 'text',site: 2,
                                  hasExistingTitle: log.existingTitles.find((d:any)=> d.siteIds.indexOf(2) > -1)? true:false,
                                  isHidden: row.siteVisibility[2],
                                  hiddenIcon: row.siteVisibility[2]? "pi pi-eye": "pi pi-eye-slash"
                                };
                                row.ttiLink = { link: "", label: "Not Yet Synced", valType: 'text',site: 3,
                                  hasExistingTitle: log.existingTitles.find((d:any)=> d.siteIds.indexOf(3) > -1)? true:false,
                                  isHidden: row.siteVisibility[3],
                                  hiddenIcon: row.siteVisibility[3]? "pi pi-eye": "pi pi-eye-slash"
                                };
                                row.ddgLink = { link: "", label: "", valType: 'Text'};
                                
                                row.landingPageInfo = log;
                                if(row.contentHubWhitePaperLinksJson){
                                  slinks = JSON.parse(row.contentHubWhitePaperLinksJson);
                                }
                                if(slinks && slinks.length > 0){
                                  slinks.forEach((l:any) => {
                                    if(l.SiteId && l.SiteId == 1){
                                     
                                      if(l.Link){
                                        row.stLink = { link: l.Link, label: "View", valType: 'label', 
                                        hasExistingTitle: log.existingTitles.find((d:any)=> d.siteIds.indexOf(1) > -1)? true:false,
                                        isHidden: row.siteVisibility[1],
                                        hiddenIcon: row.siteVisibility[1]? "pi pi-eye": "pi pi-eye-slash"
                                      };
                                      }
                                    }
                                    if(l.SiteId && l.SiteId == 2){
                                      if(l.Link){
                                        row.egLink = { link: l.Link, label: "View", valType: 'label',
                                          hasExistingTitle: log.existingTitles.find((d:any)=> d.siteIds.indexOf(2) > -1)? true:false,
                                          isHidden: row.siteVisibility[2],
                                          hiddenIcon: row.siteVisibility[2]? "pi pi-eye": "pi pi-eye-slash"
                                         };
                                      }
                                    }
                                    if(l.SiteId && l.SiteId == 3){
                                      if(l.Link){
                                        row.ttiLink = { link: l.Link, label: "View", valType: 'label' ,
                                          hasExistingTitle: log.existingTitles.find((d:any)=> d.siteIds.indexOf(3) > -1)? true:false,
                                          isHidden: row.siteVisibility[3],
                                          hiddenIcon: row.siteVisibility[3]? "pi pi-eye": "pi pi-eye-slash"
                                        };
                                      }
                                    }
                                    let ddgObj = JSON.parse(row.ddgLinksJson);
                                    if(ddgObj && ddgObj.length > 0){
                                      row.ddgLink = { link: "", label: "View", valType: 'view' };
                                    }else{
                                      row.ddgLink = { link: "", label: "Generate", valType: 'label'};
                                    }
                                  });
                                }

                              if(row.stLink.isHidden == undefined){
                                  row.stLink.hiddenIcon = "pi pi-eye";
                              }
                              if(row.egLink.isHidden == undefined){
                                  row.egLink.hiddenIcon = "pi pi-eye";
                              }
                              if(row.ttiLink.isHidden == undefined){
                                  row.ttiLink.hiddenIcon = "pi pi-eye";
                              }

                               return row;
                            });
                          }
                 // let item: any = {};
                 // if(log.landingPages && log.landingPages.length > 0){
                   // log.landingPages.forEach((row:any, index:number) => {
                          // let item: any = {};
                          // item.campaignId = log.campaignId;
                          // item.companyName = log.companyName;
                          // item.whitepaperTitle = log.title;
                          // item.lastSyncDateTime = row.lastSyncDateTime;
                     
                          // var hasLandingPageSync = log.landingPages.find((a:any) => a.lastSyncDateTime !== null);
                          // if(!hasLandingPageSync){
                          //   item.whitePaperIdLink = {
                          //     label: log.whitePaperId
                          //   }
                          //   item.valType = 'text';
                          // }else{
                          //   item.valType = 'label';
                          //   item.msgtooltip = "View Whitepaper Logs"
                          //   item.whitePaperIdLink = log.whitePaperId
                          // }
                          // itemsRow.push(item);
                          // item.criteriaForLogs = {
                          //   whitePaperId: log.whitePaperId
                          // }
                          // item.whitepaperId = log.whitePaperId;
                          // var hasLandingPageSync = log.landingPages.find((a:any) => a.lastSyncDateTime !== null);
                          // if(!hasLandingPageSync){
                          //   item.whitePaperIdLink = {
                          //     label: log.whitePaperId
                          //   }
                          //   item.valType = 'text';
                          // }else{
                          //   item.valType = 'label';
                          //   item.msgtooltip = "View Whitepaper Logs"
                          //   item.whitePaperIdLink = log.whitePaperId
                          // }
                          
                          // item.landingPageId = row.landingPageId;
                          // item.whitePaperLinkLabel = {
                          //   label: "View",
                          //   link: row.whitePaperLink
                          // }
                          // item.wpUrl = row.whitePaperLink;
                          // item.lastSyncDateTime = row.lastSyncDateTime;
                          // item.isVisible = true;
                          // item.stLink =  { link: "", label: "", valType: 'text'};
                          // item.egLink = { link: "", label: "",  valType: 'text'};
                          // if(index === 0){
                          //   item.isSelectable = true;
                          //   item.isVisible = true;
                          //   let hasAlreadyCmpId = itemsRow.find((a:any) => a.campaignId === log.campaignId)
                          //   if(!hasAlreadyCmpId){
                          //     item.campaignId = log.campaignId;
                          //     item.companyName = log.companyName;
                          //   }
                          //   item.whitepaperTitle = log.title;
                          //   itemsRow.push(item);
                          // }else{

                            
                          //   item.whitepaperTitle = row.title;
                          //   item.isSelectable = false;
                          //   item.isVisible = false;
                          //   item.whitePaperIdLink = "";

                          //   let slinks: any[] =  [];
                          //   if(row.contentHubWhitePaperLinksJson){
                          //     slinks = JSON.parse(row.contentHubWhitePaperLinksJson);
                          //   }
                          //   if(slinks && slinks.length > 0){
                          //     slinks.forEach((l:any) => {
                          //        item.stLink =  l.SiteId && l.SiteId == 1? { link: l.Link, label: "View", valType: 'label' } : { link: "", label: "Not Yet Synced", valType: 'text'};
                          //        item.egLink =  l.SiteId && l.SiteId == 2? { link: l.Link, label: "View", valType: 'label' } : { link: "", label: "Not Yet Synced", valType: 'text'};
                          //     });
                          //   }
                          // }
                       
                    //});

                 // }
              })
          }
         // data.data.items = itemsRow;
          observer.next(data.data);
      });  
  });
  }
  setlandingVisibility(params:any): Observable<any> {
    // return  this.http.post<any>(`${this.apiCampaignSync}/getWhitePapers`, params); 
    return new Observable<any>((observer) => {
      this.http.post<any>(`${this.apiCampaignSync}/setlpvisibility`, params).subscribe(data => {
          observer.next(data);
      });  
  });
  }
  getWhitePaperByCIDs(params:any): Observable<any> {
    // return  this.http.post<any>(`${this.apiCampaignSync}/getWhitePapers`, params); 
    return new Observable<any>((observer) => {
      this.http.post<any>(`${this.apiCampaignSync}/getWhitePapers`, params).subscribe(data => {
          observer.next(data.data);
      });  
  });
  }
  getWhitePaperByCampaignId(params:any): Observable<any> {
        // return  this.http.post<any>(`${this.apiCampaignSync}/getWhitePapers`, params); 
        return new Observable<any>((observer) => {
          this.http.post<any>(`${this.apiCampaignSync}/getWhitePapers`, params).subscribe(data => {
            // data.data.items = data.data.items.map((item:any) => {
            //     item.whitePaperLinkLabel = {
            //       label: item.title,
            //       link: item.whitePaperLink
            //     }
            //     return item;
            //  })
            if(data.data.items.length > 0){
                let itemsRow: any[] = []; 
                data.data.items.forEach((log:any) => {
                      let item: any = {};
                      if(log.landingPages && log.landingPages.length > 0){
                        log.landingPages.forEach((row:any, index:number) => {
                              let item: any = {};
                              var hasLandingPageSync = log.landingPages.find((a:any) => a.lastSyncDateTime !== null);
                              if(!hasLandingPageSync){
                                item.whitePaperIdLink = {
                                  label: log.whitePaperId
                                }
                                item.valType = 'text';
                              }else{
                                item.valType = 'label';
                                item.msgtooltip = "View Whitepaper Logs"
                                item.whitePaperIdLink = log.whitePaperId
                              }
                              item.criteriaForLogs = {
                                whitePaperId: log.whitePaperId
                              }
                              item.landingPageId = row.landingPageId;
                              item.whitePaperLinkLabel = {
                                label: "View",
                                link: row.whitePaperLink
                              }
                              item.wpUrl = row.whitePaperLink;
                              item.lastSyncDateTime = row.lastSyncDateTime;
                              if(index === 0){
                                item.isVisible = true;
                                itemsRow.push(item);
                              }else{
                                item.isVisible = false;
                                item.whitePaperIdLink = "";
                                itemsRow.push(item);
                              }
                        });

                      }
                  })
                  console.log(itemsRow);
                  data.data.items = itemsRow;
              }
              observer.next(data.data);
          });  
      });
  }

  invokeProcessWhitePaperSync(params:any): Observable<any> {
    return  this.http.post<any>(`${this.apiCampaignSync}/ProcessWhitePapersByCidDistributed`, params); 
  }
  generateDDGUrl(params:any): Observable<any> {
    return  this.http.post<any>(`${this.apiCampaignSync}/GenerateDDGUrl`, params); 
  }
  troubleShoot(params:any): Observable<any> {
    return  this.http.post<any>(`${this.apiCampaignSync}/troubleshoot`, params); 
  }
 getWhitePaperHeadersByWpId(wpid: number): Observable<any> {
    return  this.http.get<any>(`${this.apiCampaignSync}/getWhitePaperHeaderById?whitePaperId=${wpid}`); 
  }
  getConvertrFormFields(landingPageId: number): Observable<any> {
    return  this.http.get<any>(`${this.apiCampaignSync}/getConvertrFormFields/${landingPageId}`); 
  }
  getPostConvertrFormFields(payload: any): Observable<any> {
    return  this.http.post<any>(`${this.apiCampaignSync}/getConvertrFormFields`,payload); 
  }

  getWhitePaperSyncLogsById(params:any): Observable<any> {
    return new Observable<any>((observer) => {
        this.http.post<any>(`${this.apiCampaignSyncLogs}/getwhitepapersynclogsummaries`, params).subscribe(data => {
             data.data.items = data.data.items.map((item:any) => {
                switch(item.status){
                  case 0: {
                    item.statusName = "Started"
                    item.statusColor = "started-yellow"
                    break;
                  }
                  case 1: {
                    item.statusName = "Success"
                    item.statusColor = "completed-green"
                    break;
                  }
                  case 2: {
                    item.statusName = "Failed"
                    item.statusColor = "failed-red"
                    break;
                  }
                  case 3: {
                    item.statusName = "In Progress"
                    item.statusColor = "inprogress-blue"
                    break;
                  }
                }
                
                //item.siteCode = item.siteId === 2? 'EG': "ST";
                item.stLink =  { link: "", label: ""};
                item.egLink = { link: "", label: "" };
                item.ttiLink = { link: "", label: "" };
                let slinks =  JSON.parse(item.whitePaperLinksJson);
                if(slinks && slinks.length > 0){
                  slinks.forEach((l:any) => {
                     item.stLink =  l.SiteId && l.SiteId == 1? { link: l.Link, label: "View" } : item.stLink;
                     item.egLink =  l.SiteId && l.SiteId == 2? { link: l.Link, label: "View" } : item.egLink;
                     item.ttiLink =  l.SiteId && l.SiteId == 3? { link: l.Link, label: "View" } : item.ttiLink;
                  });
                }
                return item;
             });
             if(data.lastPaginationToken){
                data.data.lastPaginationToken = data.lastPaginationToken;
              }
             observer.next(data.data);
        }); 
    })
  }

  getCompanies(params: any): Observable<any> {
    return  this.http.post<any>(`${this.apiCampaignSync}/getCompanies`, params); 
  }

  getCampaigns(params: any): Observable<any> {
    return  this.http.post<any>(`${this.apiCampaignSync}/getCampaigns`, params); 
  }

}